(function ($) {
  /**
   * Variant Alt Text Gallery Filtering
   * Filters product gallery images based on data-variant-image-group attribute.
   * Only runs on specific product page: #shopify-section-template--27314548506988__main
   */

  // Only run on the specific product section
  var $targetSection = $("#shopify-section-template--27314548506988__main");
  if (!$targetSection.length) {
    console.log('[Gallery Alt Filter] Not target section, skip');
    return;
  }

  console.log('[Gallery Alt Filter] Script loaded - target section found');

  function filterGalleryByAltText(selectedColor) {
    console.log('[Gallery Alt Filter] filterGalleryByAltText called with:', selectedColor);

    var $gallery = $(".product-detail .gallery");
    console.log('[Gallery Alt Filter] Gallery found:', $gallery.length);

    if (!$gallery.length) {
      console.log('[Gallery Alt Filter] No gallery found, exit');
      return;
    }

    // Use data-variant-image-group attribute for filtering (already set in HTML)
    var $slideshow = $gallery.find(".slideshow");
    var $thumbnails = $gallery.find(".thumbnails");

    console.log('[Gallery Alt Filter] Slideshow found:', $slideshow.length);
    console.log('[Gallery Alt Filter] Thumbnails found:', $thumbnails.length);

    var normalizedColor = selectedColor.trim();
    console.log('[Gallery Alt Filter] Filtering for color:', normalizedColor);

    // Filter main slideshow slides using data-variant-image-group
    if ($slideshow.length && $slideshow.hasClass("slick-initialized")) {
      console.log('[Gallery Alt Filter] Using slick filter for slideshow');

      // Unfilter first to show all, then filter to selected color
      $slideshow.slick('slickUnfilter');

      var groupFilter = "[data-variant-image-group=\"" + normalizedColor + "\"]";
      console.log('[Gallery Alt Filter] Slick filter selector:', groupFilter);

      $slideshow.slick('slickFilter', groupFilter);
      $slideshow.slick('slickGoTo', 0, true);
    } else {
      // Fallback: manually show/hide slides
      var $slides = $gallery.find(".slide");
      console.log('[Gallery Alt Filter] Fallback slide filtering, slides found:', $slides.length);

      $slides.each(function () {
        var $slide = $(this);
        var groupValue = $slide.attr("data-variant-image-group");
        console.log('[Gallery Alt Filter] Slide group:', groupValue, '| Looking for:', normalizedColor);

        if (groupValue === normalizedColor) {
          $slide.show();
        } else {
          $slide.hide();
        }
      });
    }

    // Filter thumbnails using data-variant-image-group
    if ($thumbnails.length) {
      console.log('[Gallery Alt Filter] Filtering thumbnails');
      $thumbnails.find(".thumbnail").each(function () {
        var $thumb = $(this);
        var groupValue = $thumb.attr("data-variant-image-group");
        console.log('[Gallery Alt Filter] Thumbnail group:', groupValue, '| Looking for:', normalizedColor);

        if (groupValue === normalizedColor) {
          $thumb.show();
        } else {
          $thumb.hide();
        }
      });
    }

    console.log('[Gallery Alt Filter] Filtering complete');
  }

  function resetGallery() {
    console.log('[Gallery Alt Filter] resetGallery called');
    var $gallery = $(".product-detail .gallery");
    var $slides = $gallery.find(".slick-slide, .product-media--image, .slide, .thumbnails .thumbnail");

    $slides.show();

    if ($gallery.hasClass("slick-initialized")) {
      $gallery.slick("setPosition");
    }
  }

  // Listen for color swatch changes in the option-selector__btns - scoped to target section
  // Structure: fieldset > div.option-selector__btns > input[type=radio]
  // Radio value IS the color name (e.g., "White", "Black", "Charcoal")
  $targetSection.on("change", ".option-selector__btns input[type=radio]", function (e) {
    var $input = $(this);
    var selectedColor = $input.val();
    console.log('[Gallery Alt Filter] Radio change event | Selected color:', selectedColor);

    // Check if this is a color selector by looking at the legend
    var $fieldset = $input.closest("fieldset");
    var legendText = $fieldset.find("legend.label").text() || "";
    console.log('[Gallery Alt Filter] Legend text:', legendText.trim());

    if (legendText.toLowerCase().indexOf("color") !== -1) {
      console.log('[Gallery Alt Filter] → Color swatch clicked, filtering gallery');
      filterGalleryByAltText(selectedColor);
    } else {
      console.log('[Gallery Alt Filter] → Not a color swatch, skip');
    }
  });

  // Also handle the variantColorChanged event from custom.js
  $targetSection.on("variantColorChanged", function (event, color) {
    console.log('[Gallery Alt Filter] variantColorChanged event | Color:', color);
    filterGalleryByAltText(color);
  });

  // Initialize on page load - check URL for variant or selected color
  $(window).on("load", function () {
    console.log('[Gallery Alt Filter] Window load event');
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get("variant");

    if (variantId) {
      console.log('[Gallery Alt Filter] Variant ID in URL:', variantId);
      // Find the selected variant and get its color option within target section
      var $variantOption = $targetSection.find('.original-selector option[value="' + variantId + '"]');
      if ($variantOption.length) {
        var variantText = $variantOption.text();
        console.log('[Gallery Alt Filter] Variant text:', variantText);
        var colorMatch = variantText.match(/^\s*([^\/]+)/);
        if (colorMatch) {
          console.log('[Gallery Alt Filter] Page load - detected color:', colorMatch[1]);
          // filterGalleryByAltText(colorMatch[1]);
        }
      }
    }
  });

  // Page visibility change - in case DOM loads after window.load
  $targetSection.on("ready", function() {
    console.log('[Gallery Alt Filter] Section ready');
  });

})(theme.jQuery);
